module.exports = __webpack_public_path__ + "static/media/e_jugend.6092d4f1.jpg";